<template>
  <div id="addGoodsPurchaseReturn">
    <div class="invoicingHead" style="height:40px;">
        <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <a @click="jumpTT('/invoicingFather/goodsPurchaseReturn')" href="javascript:;">进货退货单管理</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>新增进货退货单</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="invoicingHeadDown">
        <div>
            <span style="padding: 10px 10px 20px 20px;">关联单据退货</span>
            <el-switch v-model="value" active-color="#409EFF" inactive-color="#ccc" @change="swithChange"></el-switch>
        </div>
        <div class="formClass" v-show="isShow">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="业务日期">
                  <el-date-picker v-model="form.dataTime" :clearable="false" type="datetime" placeholder="选择业务日期" @change="dataTimeChoose" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                </el-form-item>
                <el-form-item label="经手人">
                  <el-select size="small" v-model="form.shopWorkerUserId" placeholder="经手人" @change="shopWorkerUserIdChange">
                    <el-option v-for="item in handlerList" :key="item.shopWorkerUserId" :label="item.fullName" :value="item.shopWorkerUserId"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="供应商">
                    <el-select size="small" v-model="form.supplierId" placeholder="供应商" @change="supplierIdChange">
                        <el-option v-for="item in supplierList" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出库仓库">
                    <el-select size="small" v-model="form.repositoryId" placeholder="出库仓库" @change="repositoryChange">
                        <el-option v-for="item in repositoryGoodsList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 20px;margin-left:20px">
            <el-button type="primary" @click="jumpTT('/invoicingFather/chooseGoodsPurchasePrice')" v-if="value == true">选择进货单</el-button>
            <el-button type="primary" @click="go" v-if="value == false">选择商品</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import { Shop_handlerList, supplierList, repositoryList, defaultParam } from '../api';
export default {
    data() {
        return {
            userList: {},
            value: false,
            form: {
                dataTime: "",
                shopWorkerUserId: "",
                repositoryId: "",
                supplierId: "",
                shopStoreId: ""
            },
            handlerList: [],
            repositoryGoodsList: [],
            supplierList: [],
            isShow: true
        }
    },
    created() {
        let userList = JSON.parse(this.getCookie("userList"));
        this.userList = userList;
        this.getDefaultParam()
        this.Shop_handlerList()
        if (this.value == true) {
            this.isShow = false
        }
    },
    methods: {
        // 传门店ID
        go() {
            if (this.form.dataTime == null) {
                this.$message.error("请选择业务日期")
                return
            }
            localStorage.setItem("goodsStyle", 2)
            sessionStorage.setItem("dataTimes", this.form.dataTime)
            this.$router.push({path: '/invoicingFather/chooseGoods', query: { form: this.form, goodsStyle: localStorage.getItem("goodsStyle") }})
            // localStorage.setItem("shopStoreId", this.form.shopStoreId)
        },
        //跳转
        jumpTT(adress, message) {
          this.$router.push({ path: adress, query: { docId: message } });
        },
        // 获取默认参数
        getDefaultParam() {
            defaultParam({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 99999
            })
            .then(res => {
                if (res.code == 1) {
                    this.form.dataTime = res.data.repository.modifyTime
                    this.form.shopWorkerUserId = res.data.handler.shopWorkerUserId
                    this.form.supplierId = res.data.supplier.supplierId
                    this.form.repositoryId = res.data.repository.repositoryId
                    this.form.shopStoreId = res.data.repository.shopStoreId
                    localStorage.setItem("checkSupplierId", this.form.supplierId)
                    localStorage.setItem("checkShopWorkerUserId", this.form.shopWorkerUserId)
                    localStorage.setItem("checkRepositoryId", this.form.repositoryId)
                    localStorage.setItem("checkShopStoreId", this.form.shopStoreId)
                    localStorage.setItem("repositoryInId", this.form.repositoryId)
                    var index = this.repositoryGoodsList.findIndex(item => {
                        return item.repositoryId == this.form.repositoryId
                    })
                    if (index !== -1) {
                        localStorage.setItem("repositoryInName", this.repositoryGoodsList[index].repositoryName)
                    }
                }
            })
        },
        // 选择业务日期
        dataTimeChoose() {
            console.log(this.form.dataTime)
        },
        // 经手人列表
        Shop_handlerList() {
            Shop_handlerList({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 99999
            })
            .then(res => {
                if (res.code == 1) {
                    this.handlerList = res.data[0].workers
                    // this.handlerList.unshift( { fullName: "全部经手人", shopWorkerUserId: "" } )
                    this.getSupplierList()
                }
            })
        },
        // 获取供应商列表
        getSupplierList() {
            supplierList({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 99999
            })
            .then(res => {
                if (res.code == 1) {
                    this.supplierList = res.data
                    // this.supplierList.unshift( { supplierName: "全部供应商", supplierId: "" } )
                    this.repositoryGoodsDetailList()
                }
            })
        },
        // 是否关联商品
        swithChange(e) {
            if (e == true) {
                this.isShow = false
            } else {
                this.isShow = true
            }
        },
        // 获取仓库列表
        repositoryGoodsDetailList() {
            repositoryList({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 99999
            })
            .then(res => {
                if (res.code == 1) {
                    this.repositoryGoodsList = res.data
                }   
            })
        },
        // 经手人
        shopWorkerUserIdChange(val) {
            localStorage.setItem("checkShopWorkerUserId", val)
        },
        // 供应商
        supplierIdChange(val) {
          localStorage.setItem("checkSupplierId", val)
        },
        // 仓库发生变化 
        repositoryChange(val) {
            var index = this.repositoryGoodsList.findIndex(item => {
                return val == item.repositoryId
            })
            if (index !== -1) {
              localStorage.setItem("checkShopStoreId", this.repositoryGoodsList[index].shopStoreId)
              localStorage.setItem("repositoryInName", this.repositoryGoodsList[index].repositoryName)
              localStorage.setItem("repositoryInId", this.repositoryGoodsList[index].repositoryId)
            }
            localStorage.setItem("checkRepositoryId", val)
        }
    }
}
</script>

<style scoped>
.formClass {
    width: 500px;
    height: auto;
    background-color: #F8F8F8;
    margin: 20px 0;
    padding: 10px;
}
.scanner {
    padding-left: 20px;
    padding-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/addGoodsPurchaseReturn.vue